import React from 'react';
import { Chip, Box } from '@mui/material';
import type { HelpAudience } from '../../help/types';
import { appColors } from '../../Config/Theme';

const audienceColorMap: Record<HelpAudience, string> = {
  'Incident Commander': appColors.primary.main,
  'Headcounter': appColors.status.success,
  'Admin': appColors.status.accent,
  'Viewer': appColors.text.caption,
};

interface HelpRoleChipsProps {
  audience: HelpAudience[];
}

const HelpRoleChips: React.FC<HelpRoleChipsProps> = ({ audience }) => (
  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
    {audience.map((role) => (
      <Chip
        key={role}
        label={role}
        size="small"
        sx={{
          fontWeight: 600,
          fontSize: '0.7rem',
          height: 22,
          borderRadius: '10px',
          bgcolor: `${audienceColorMap[role]}14`,
          color: audienceColorMap[role],
          border: `1px solid ${audienceColorMap[role]}40`,
        }}
      />
    ))}
  </Box>
);

export default HelpRoleChips;
